import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Pencil, Plus } from "lucide-react";
import { api, formatErr } from "../../lib/api";

const EMPTY = { name: "", sector: "", country: "", market: "", category: "consulenza", logo_url: "", website: "", order: 0 };
const FIELDS = [["name", "Nome azienda *"], ["sector", "Settore"], ["country", "Paese"], ["market", "Mercato (es. Iran, Dubai)"], ["logo_url", "URL logo (https://…)"], ["website", "Sito web (https://…)"], ["order", "Ordine"]];

export const AdminClients = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const load = () => api.get("/clients").then((r) => setItems(Array.isArray(r.data) ? r.data : []));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { ...form, order: Number(form.order) || 0 };
      if (editId) await api.put(`/admin/clients/${editId}`, body);
      else await api.post("/admin/clients", body);
      toast.success(editId ? "Cliente aggiornato" : "Cliente aggiunto");
      setForm(EMPTY);
      setEditId(null);
      load();
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    }
  };
  const remove = async (id) => {
    if (!window.confirm("Eliminare questo cliente?")) return;
    await api.delete(`/admin/clients/${id}`);
    toast.success("Cliente eliminato");
    load();
  };
  const edit = (c) => { setEditId(c.id); setForm({ ...EMPTY, ...c }); };
  return (
    <div className="grid lg:grid-cols-5 gap-8">
      <form data-testid="admin-client-form" onSubmit={save} className="lg:col-span-2 border border-[var(--line)] rounded-md p-6 bg-[var(--ink-2)] h-fit">
        <h2 className="font-semibold text-lg">{editId ? "Modifica cliente" : "Nuovo cliente"}</h2>
        <label className="block mt-4"><span className="mono text-[11px] uppercase text-[rgba(246,241,232,0.7)]">Categoria</span>
          <select data-testid="admin-client-category-select" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="field cursor-pointer">
            <option value="consulenza">Consulenza</option>
            <option value="import">Import-Export</option>
          </select>
        </label>
        {FIELDS.map(([k, l]) => (
          <label key={k} className="block mt-4"><span className="mono text-[11px] uppercase text-[rgba(246,241,232,0.7)]">{l}</span>
            <input data-testid={`admin-client-${k}-input`} type={k === "order" ? "number" : "text"} required={k === "name"} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="field" /></label>
        ))}
        <div className="flex gap-3 mt-6">
          <button data-testid="admin-client-save" className="flex items-center gap-2 rounded-full bg-[var(--amber)] text-[var(--ink)] px-5 py-2.5 text-sm font-semibold hover:bg-[var(--bone)]"><Plus className="w-4 h-4" />{editId ? "Salva" : "Aggiungi"}</button>
          {editId && <button type="button" data-testid="admin-client-cancel" onClick={() => { setEditId(null); setForm(EMPTY); }} className="rounded-full border border-[var(--line)] px-5 py-2.5 text-sm">Annulla</button>}
        </div>
      </form>
      <ul data-testid="admin-clients-list" className="lg:col-span-3 space-y-3">
        {!items.length && <li className="text-[rgba(246,241,232,0.7)]">Nessun cliente. Aggiungi il primo dal modulo.</li>}
        {items.map((c) => (
          <li key={c.id} data-testid={`admin-client-${c.id}`} className="flex items-center gap-4 border border-[var(--line)] rounded-md p-4">
            <div className="w-14 h-14 rounded bg-[var(--bone)] grid place-items-center overflow-hidden shrink-0">
              {c.logo_url ? <img src={c.logo_url} alt={c.name} className="max-w-[80%] max-h-[80%] object-contain" /> : <span className="display text-[var(--ink)] text-sm">{c.name.slice(0, 2)}</span>}
            </div>
            <div className="flex-1 min-w-0"><p className="font-semibold truncate">{c.name}</p><p className="mono text-[11px] text-[rgba(246,241,232,0.7)] truncate">{[c.category === "import" ? "Import-Export" : "Consulenza", c.sector, c.country, c.market].filter(Boolean).join(" · ")}</p></div>
            <button data-testid={`admin-client-edit-${c.id}`} onClick={() => edit(c)} className="p-2 rounded-full border border-[var(--line)] hover:border-[var(--amber)]"><Pencil className="w-4 h-4" /></button>
            <button data-testid={`admin-client-delete-${c.id}`} onClick={() => remove(c.id)} className="p-2 rounded-full border border-[var(--line)] hover:border-red-400 hover:text-red-300"><Trash2 className="w-4 h-4" /></button>
          </li>
        ))}
      </ul>
    </div>
  );
};
